import _ from 'underscore';
import URI from 'urijs';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '@bingads-webui-campaign-react/router';
import { siteMapPropType, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { SimpleSummaryBar } from '@bingads-webui-campaign-react/summary-bar';
import { withScope } from '@bingads-webui-react/scope-service';
import { getBrandListById } from '@bingads-webui-campaign-react/brand-lists-data';

const SITE_MAP_ID = 'brand-lists';

export const Loader = (props) => {
  const {
    siteMap,
    breadCrumbText,
    backButtonText,
    backButtonUrl,
    updateAvailability,
    scope,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  const {
    values: {
      uid,
      cid,
      aid,
      brandListId,
    },
  } = scope;
  const [listName, setListName] = useState('');

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const brandList = await getBrandListById({ cid, aid, brandListId });
        setListName(brandList ? brandList.Name : '');
      } catch (error) {
        // No error notification here since it's summary bar, which won't block the normal workflow.
        setListName('');
      }
    }

    if (brandListId) {
      fetchData();
    }
  }, [aid, brandListId, cid]);

  // Add Brand List breadcrumb.
  // The parent ID is shared by the account-level entrypoints in the sitemap.
  if (scope.values.brandListId && selectedParent && selectedParent.id === SITE_MAP_ID && scope.location.pathname.includes('details')) {
    const path = getRoutePathById(siteMap, SITE_MAP_ID);
    const breadcrumbUrl = new URI(path)
      .addQuery({ uid, cid, aid })
      .toString();

    const additionalItems = [];
    additionalItems.push({
      key: `navigate-brandListId-${brandListId}`,
      text: listName,
    });

    return (
      <SimpleSummaryBar
        selectedParent={selectedParent}
        breadCrumbText={breadCrumbText}
        breadcrumbUrl={breadcrumbUrl}
        backButtonText={backButtonText}
        backButtonUrl={backButtonUrl}
        additionalItems={additionalItems}
      />
    );
  }
  return selectedParent ? (
    <SimpleSummaryBar
      selectedParent={selectedParent}
      breadCrumbText={breadCrumbText}
      backButtonText={backButtonText}
      backButtonUrl={backButtonUrl}
      {...others}
    />
  ) : null;
};

Loader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  breadCrumbText: PropTypes.string,
  backButtonText: PropTypes.string,
  backButtonUrl: PropTypes.string,
  updateAvailability: PropTypes.func,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      brandListId: PropTypes.number,
      uid: PropTypes.string,
      cid: PropTypes.string,
      aid: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

Loader.defaultProps = {
  breadCrumbText: null,
  backButtonText: null,
  backButtonUrl: null,
  updateAvailability: _.noop,
};

export const BrandListsDetailsPageLoader = withScope(withRouter(React.memo(Loader)));
